import {Pipe, PipeTransform} from "@angular/core";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Mobilnummer} from "../tjenester/ressurser/generertNg2HttpKlient";

@Pipe({name: 'mobilnummer', pure: true, standalone: true})
export class FormaterMobilnummerPipe implements PipeTransform {
    constructor() {
    }

    transform(value: Mobilnummer | null): string | null {
        return formater(value);
    }
}

let norskNummerMedLandKode: RegExp = /^(\+\d{2})(\d{3})(\d{2})(\d{3})$/;
let norskNummerUtenLandkode = /^(\d{3})(\d{2})(\d{3})$/;

function formater(mobilnummer: Mobilnummer | null) {
    if (erNil(mobilnummer)) return '';

    if (norskNummerMedLandKode.test(mobilnummer)) {
        let nummer = norskNummerMedLandKode.exec(mobilnummer)!;
        return nummer.slice(1).join(' ');
    }

    if (norskNummerUtenLandkode.test(mobilnummer)) {
        let nummer = norskNummerUtenLandkode.exec(mobilnummer)!;
        return nummer.slice(1).join(' ');
    }

    return mobilnummer;
}
